import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { Resource } from '@monorepo/shared/src/providers/ResourcesProvider/types';
import GET_RESOURCES from '@monorepo/shared/src/graph/queries/resources/get-resources-query';

export type ProfessionalLearningResourcesStoreState = {
  resources: Resource[];
  error: ApolloError | undefined;
  isLoading: boolean;
};

const useProfessionalLearningResourcesStore = (): ProfessionalLearningResourcesStoreState => {
  const { data, loading, error }: QueryResult<{ resources: Resource[] }> = useQuery(GET_RESOURCES, {
    variables: {
      where: {
        resourceTypeId: 9,
      },
    },
  });

  return {
    resources: data?.resources || [],
    error,
    isLoading: loading,
  };
};

export default useProfessionalLearningResourcesStore;
